const DESC_ORDER = "desc";

export const initialState = {
  isCancelModalOpen: false,
  guestToDelete: {},
  isGuestGrid: true,
  guestFilterText: "",
  viewByValue: 0,
  orderDirection: DESC_ORDER,
  orderBy: "id",
  records: [],
  guestsFoundCount: 0,
  guests: [
    { id: 1, name: "George Washington" },
    { id: 2, name: "Thomas Jefferson" },
    { id: 3, name: "John Adams" },
    { id: 4, name: "James Madison" }
  ],
  guestGroups: [
    { id: 1, name: "presidents", numberOfGuests: 2 },
    { id: 2, name: "vice presidents", numberOfGuests: 3 }
  ]
};

export const radioOptions = [{ name: "View by Guest", value: 0 }, { name: "View by Guest Group", value: 1 }];
